export enum PriceTypes {
  b2b = 'entrepreneur',
  b2c = 'consumer',
}
